import { FC } from 'react';
import classNames from 'classnames';
import styles from './customEditorWrapper.module.scss';
import { CustomEditorWrapperProps, FooterVariant } from '../customEditorTypes';
import CustomEditor from '../customEditor';
import EditorHeader from '../editorHeader/editorHeader';
import EditorFooter from '../editorFooter/editorFooter';

const CustomEditorWrapper: FC<CustomEditorWrapperProps> = (props: CustomEditorWrapperProps) => {
    const {
        code,
        onCodeChange,
        readOnly,
        codeSections = [],
        theme,
        language,
        includeActions,
        mainAction,
        secondaryAction,
        id,
        headerVariant,
        footerVariant,
        userLogo,
        completedMask,
        percentage,
        outOfTries,
        headerActions,
        userNickname,
        isGameDone
    } = props;

    const secondaryActionHandler = () => {
        secondaryAction?.();
    };

    const mainActionHandler = () => {
        mainAction?.();
    };

    return (
        <div className={styles.container}>
            <div className={classNames(styles.wrapper, completedMask && styles['completed-mask'])}>
                <EditorHeader
                    styleVariant={headerVariant}
                    userLogo={userLogo}
                    completedMask={completedMask}
                    headerActions={headerActions}
                    userNickname={userNickname}
                />
                <div className={styles['editor-container']}>
                    <CustomEditor
                        code={code}
                        onCodeChange={onCodeChange}
                        codeSections={codeSections}
                        readOnly={readOnly || codeSections.length > 0}
                        theme={theme}
                        language={language}
                        id={id}
                    />
                </div>
            </div>
            {includeActions && (
                <EditorFooter
                    secondaryAction={secondaryActionHandler}
                    mainAction={mainActionHandler}
                    styleVariant={footerVariant as FooterVariant}
                    percentage={percentage}
                    outOfTries={outOfTries}
                    isGameDone={isGameDone}
                />
            )}
        </div>
    );
};

export default CustomEditorWrapper;
